var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 95,
    viewBox: "0 0 87 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 21.1799V0.617432H57.3407V32.9299H51.4088V50.5549H25.7053V68.1799H0V94.6174H80.0801V32.9299H60.3066V21.1799H87ZM60.3066 3.55493H84.0341V18.2424H60.3066V3.55493ZM28.6713 53.4924H51.4107V58.3889H28.6713V53.4924ZM2.96593 71.1174H25.7053V76.0139H2.96593V71.1174ZM77.1142 91.6799H2.96593V78.9514H25.7053V85.3166H28.6713V61.3264H51.4107V71.6076H54.3766V43.7014H77.1142V91.6799ZM77.1142 35.8674V40.7639H54.3748V35.8674H77.1142Z",
    fill: "#CDA274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5852 6.49243H72.6653V9.42993H79.5852V6.49243Z",
    fill: "#CDA274"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.585 12.3674H64.7554V15.3049H79.585V12.3674Z",
    fill: "#CDA274"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1303 11.3889V14.3264H40.4145L3.39966 50.9845L5.49805 53.0628L42.511 16.4028V22.6487H45.4769V11.3889H32.1303Z",
    fill: "#CDA274"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39072 81.8889H5.43677V84.8264H9.39072V81.8889Z",
    fill: "#CDA274"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2325 81.8889H19.2786V84.8264H23.2325V81.8889Z",
    fill: "#CDA274"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0963 64.2639H31.1423V67.2014H35.0963V64.2639Z",
    fill: "#CDA274"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9378 64.2639H44.9839V67.2014H48.9378V64.2639Z",
    fill: "#CDA274"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8016 46.6389H56.8477V49.5764H60.8016V46.6389Z",
    fill: "#CDA274"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6412 46.6389H70.6873V49.5764H74.6412V46.6389Z",
    fill: "#CDA274"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.515033b941a89c6b1ab80b9b197fbcec.svg";
export { ForwardRef as ReactComponent };